<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createDocflow') }}</h1>
      <div class="form-container">
        <DocflowIncomingForm @save="save"></DocflowIncomingForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowIncomingForm from '@/components/DocflowIncomingForm'

  export default {
    components: {
      DashboardLayout,
      DocflowIncomingForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/create', {
          ...documentForm,
          category: 'incoming'
        }).then(document => {
          this.$router.push({
            name: 'docflowIncomingDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {category: 'incoming', documentId: null})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowIncoming', path: 'docflowIncoming'},
          {name: 'createDocflow'}
        ]
      }
    }
  }
</script>
